module.exports = "<div class=\"js-dropdown-region dev-mention-editor__dropdown-region\"></div>";